import React, { PropsWithChildren } from "react";
import { useAuthenticationContext } from "../../../../contexts/UserContext";
import { Button } from "../../../components/buttons/Button";
import { ReactComponent as Exclamation } from "../../../../resources/icons/circle-exclamation.svg";
import { ContentHeader } from "../../../components/structure/ContentHeader";
import { useAuthHttpClient } from "../../../../api/api-hooks/useAuthHttpClient";

export function PrivilegesGuard({ children }: PropsWithChildren) {
    const { user } = useAuthenticationContext();
    const isAuthenticated = !!user;
    const hasRoles = isAuthenticated && user.roles.length > 0;
    return <>{hasRoles ? children : <NoPrivileges />}</>;
}

export function NoPrivileges() {
    const { signOut } = useAuthHttpClient();
    return (
        <>
            <div className={"flex flex-col items-center mx-auto mt-[120px]"}>
                <Exclamation className={"h-[200px] w-[200px] mb-60"} />
                <ContentHeader className={"text-l mb-16"}>
                    Din MitID-bruger har ikke tilstrækkelige rettigheder
                </ContentHeader>
                <p
                    className={
                        "text-xn break-normal max-w-[650px] mb-32 text-center"
                    }
                >
                    Din MitID-bruger har ikke tilstrækkelige rettigheder.
                    <br />
                    Kontakt din rettighedsadministrator til MitID Erhverv.
                </p>
                <Button onClick={signOut} size={"m"} theme={"secondary"}>
                    Log ud
                </Button>
            </div>
        </>
    );
}
